// src/pages/hr/HRLearning.jsx
import React from "react";
import HRComingSoon from "./HRComingSoon";

export default function HRLearning() {
  return (
    <HRComingSoon
      icon="📚"
      title="Learning & Development"
      description="Manage training programs, course catalog, certifications, skill assessments, and employee learning progress reports. Coming soon."
    />
  );
}
